import $ from "jquery";
import getLayout from "./get-modal-layout";
import Modal from "./modal";

class ModalTrezini extends Modal {
  constructor() {
    super();
    this.toggle = this.page.querySelector(`.js-modal-trezini`);
  }

  init(locale) {
    super.createModal();
    this.locale = locale;
    this.createWrap();
    this.bindHandlers();
  }

  createWrap() {
    super.addLayout(`<div class="trezini-certificate"></div>`);
  }

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
  };

  bindHandlers() {
    this.toggle &&
      this.toggle.addEventListener(`click`, (ev) => {
        ev.preventDefault();
        this._toggleModal(true);
      });
  }
}

const modalTrezini = new ModalTrezini();

export default modalTrezini;
